import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';
import logo from '../../assets/logo.png';
import { logOut } from '../../store/ducks/auth';
import Burguer from './Menu/Burguer';

const Container = styled.div`
  background: #fff;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 768px) {
    padding: 10px;
    width: auto;
  }
`;

const Content = styled.div`
  display: flex;
  justify-content: space-between;
  width: 90%;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const LeftSide = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 175px;
    height: auto;
  }
`;

const Right = styled.div`
display: flex;
  align-items: center;
  justify-content: center;

 @media (max-width: 768px) {
    display: none;
  }
`;

const RightSide = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  .button-header {
    margin-left: 15px;
    width: 140px;
    height: 55px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #6a6a6a;


    i {
      font-size: 20px;
      margin-right: 10px;
    }

    &:hover {
      text-decoration: none;
    }
  }

  .button-location {
    border: 1px solid #f3f3f3;
    border-radius: 5px;
    display: flex;
    line-height: 18px;

    i {
      font-size: 25px;
    }

    p {
      margin: 0;
      padding: 0;
      font-size: 8px;
    }
  }

  .button-filled-red {
    width: 140px;
    height: 55px;
    background: #ce1720;
    border: 2px solid #ce1720;
    border-radius: 5px;
    color: white;
    font-weight: 500;
  }

  .button-outline-red {
    width: 140px;
    height: 55px;
    background: white;
    border: 2px solid #ce1720;
    border-radius: 5px;
    color: #ce1720;
    font-weight: 500;

    @media (max-width: 768px) {
      margin-right: -20px;
    }
  }
`;

const MenuMobile = styled.div`
  display: none;

  @media (max-width: 768px) {
    position: relative;
    display: flex;
    flex-flow: column nowrap;
    float: right;
    top: 0;
    height: 100px;
    width: 100px;
    padding-top: 10px;

    li {
      color: #fff;
    }
  }
`

function Header() {
  const userData = useSelector((state) => state.auth.user_data);
  const mainAddress = useMemo(
    () =>
      userData && userData.addresses?.length
        ? `${userData.addresses[0].address} , ${userData.addresses[0].number}`
        : '',
    [userData]
  );
  const dispatch = useDispatch();

  return (
    <Container>
      <Content>
        <LeftSide>
          <Link to="/">
            <img src={logo} alt="Logo" id="top" />
          </Link>
        </LeftSide>
        <RightSide>

          {useSelector((state) => state.auth.user_logged_in) > 0 ? (
            <>
              <Right>
                <Link className="button-header" to="/usuario/vitrine">
                  <i className="fas fa-user" />
                Minha Conta
              </Link>

                <Link className="button-header button-location" to="/" style={{ width: '300px', padding: '20px' }}>
                  <div>
                    <i className="fas fa-map-marker-alt" />
                  </div>
                  <div>
                    <p>Localização</p>
                    <strong>{mainAddress}</strong>
                  </div>
                </Link>
              </Right>
              <Link className="button-header button-outline-red" to="/produto/cadastro">
                Anuncie
              </Link>
              <Right>

                <Link
                  className="button-header button-filled-red"
                  onClick={() => dispatch(logOut())}
                  to="/">
                  Sair
              </Link>
              </Right>
              <MenuMobile>
                <Burguer />
              </MenuMobile>
            </>
          ) : (
            <>
              <Link className="button-header" to="/usuario/cadastro">
                <i className="far fa-heart" />
                Cadastre-se
              </Link>
              <Link className="button-header button-filled-red" to="/entrar">
                Login
                </Link>
            </>
          )}
        </RightSide>
      </Content>
    </Container>
  );
}

export default Header;
